// extracted by mini-css-extract-plugin
export default {"wrapper":"main-layout_wrapper__1mfil","chatWrapper":"main-layout_chatWrapper__wKh0z","profileWrapper":"main-layout_profileWrapper__jGy2h"};